import { Brand, SubBrand } from '../types/asset';

export function isBrand(brand: any): brand is Brand {
  return !!(brand as Brand)?.name;
}

export function isSubBrand(subBrand: any): subBrand is SubBrand {
  return !!(subBrand as SubBrand)?.name;
}
